<template>
  <v-app>
    <router-view name="sidebar" />
    <router-view name="header" :handleSettingsDrawer="handleSettingsDrawer" />
    <v-main class="vuse-content">
      <v-fade-transition>
        <router-view />
      </v-fade-transition>
    </v-main>
    <router-view name="footer" />
    <app-settings-drawer
      :handleDrawer="handleSettingsDrawer"
      :drawer="settingsDrawer"
    />
  </v-app>
</template>

<script>
import AppSettingsDrawer from "@/layouts/App/AppSettingsDrawer";
/*
import Axios from "./services/axios";
import store from "./store";

//https://www.youtube.com/watch?v=nTJP2q2NIwM
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArt4-n00317yj1u6hNs1PKfj3n5mM_BRo",
  authDomain: "ibooknotifications.firebaseapp.com",
  projectId: "ibooknotifications",
  storageBucket: "ibooknotifications.appspot.com",
  messagingSenderId: "814633122882",
  appId: "1:814633122882:web:fd18fa6e35c751103301db",
  measurementId: "G-SDKX86SD7G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log(analytics);

// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
const messaging = getMessaging();
onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
  // ...
});


async function addDB (token)
{
  try{
      var customerId=null;
      if (!localStorage.getItem('customerId'))
      {
        const res = await Axios.post('/API/fcm/fcm.php', {"fcmToken":token,"hostname":window.location.hostname,"bindId":localStorage.getItem('bindId')});
        console.log(71,res);
        //localStorage.setItem('customerId',res.data.customerId)
        store.dispatch("setPushSubscribed",true);
        return true;
      }
      else
      {
        customerId=localStorage.getItem('customerId')
        const res = await Axios.post('/API/fcm/fcm.php', {"fcmToken":token,"customerId":customerId,"hostname":window.location.hostname,"bindId":localStorage.getItem('bindId')});
        console.log(79,res);
        return true;
      }      
  } catch(e)
  {
  console.log(e);
  }
}

getToken(messaging, { vapidKey: 'BN0j_Y-xwZu9f9jhq520_Kx1xYP4dP1rEvbUf-NLQmV2Gzo-TEmpe6U92sJoRtJppNJ7-lLQ_uAGxuwkWXd7Id4' }).then((currentToken) => {
  if (currentToken) {
    // Send the token to your server and update the UI if necessary
    // ...
    //localStorage.setItem('fcmToken',currentToken)
    addDB(currentToken);
    //console.log('91 App.vue',rsp)
  } else {
    // Show permission request UI
    console.log('No registration token available. Request permission to generate one.');
    // ...
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
  // ...
});
*/



export default {
  data: () => {
    return {
      settingsDrawer: false,
    };
  },
  components: {
    AppSettingsDrawer
  },
  methods: {
    handleSettingsDrawer() {
      this.settingsDrawer = !this.settingsDrawer;
    }
  },
};
</script>

<style>
/* Custom MDI font-class override for pig-off */
.v-icon.mdi-pig-off::before {
  content: "" !important;
  display: inline-block !important;
  width: 1em !important;
  height: 1em !important;
  vertical-align: -0.15em !important;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.5,9A1.5,1.5 0 0,0 8,10.5A1.5,1.5 0 0,0 9.5,12A1.5,1.5 0 0,0 11,10.5A1.5,1.5 0 0,0 9.5,9M14.5,9A1.5,1.5 0 0,0 13,10.5A1.5,1.5 0 0,0 14.5,12A1.5,1.5 0 0,0 16,10.5A1.5,1.5 0 0,0 14.5,9M12,4L12.68,4.03C13.62,3.24 14.82,2.59 15.72,2.35C17.59,1.85 20.88,2.23 21.31,3.83C21.62,5 20.6,6.45 19.03,7.38C20.26,8.92 21,10.87 21,13A9,9 0 0,1 12,22A9,9 0 0,1 3,13C3,10.87 3.74,8.92 4.97,7.38C3.4,6.45 2.38,5 2.69,3.83C3.12,2.23 6.41,1.85 8.28,2.35C9.18,2.59 10.38,3.24 11.32,4.03L12,4M10,16A1,1 0 0,1 11,17A1,1 0 0,1 10,18A1,1 0 0,1 9,17A1,1 0 0,1 10,16M14,16A1,1 0 0,1 15,17A1,1 0 0,1 14,18A1,1 0 0,1 13,17A1,1 0 0,1 14,16M12,13C9.24,13 7,15.34 7,17C7,18.66 9.24,20 12,20C14.76,20 17,18.66 17,17C17,15.34 14.76,13 12,13M7.76,4.28C7.31,4.16 4.59,4.35 4.59,4.35C4.59,4.35 6.8,6.1 7.24,6.22C7.69,6.34 9.77,6.43 9.91,5.9C10.06,5.36 8.2,4.4 7.76,4.28M16.24,4.28C15.8,4.4 13.94,5.36 14.09,5.9C14.23,6.43 16.31,6.34 16.76,6.22C17.2,6.1 19.41,4.35 19.41,4.35C19.41,4.35 16.69,4.16 16.24,4.28Z"/><line x1="2.42" y1="1.64" x2="22.36" y2="21.58" stroke="%23FFFFFF" stroke-width="1.1" stroke-linecap="butt"/><line x1="1.64" y1="2.42" x2="21.58" y2="22.36" stroke="currentColor" stroke-width="1.1" stroke-linecap="butt"/></svg>') no-repeat center / contain !important;
}
</style>